<template>
  <v-dialog :value="$store.state.appointmentsSelectedDayPage.showAppointmentBookingDialog" width="900" persistent v-if="computedSelectedSlot">
    <v-card class="hoh-entry-form">
      <v-card-title class="headline primary white--text" primary-title>
        {{ translate($store.getters.content.appointment_booking) }}
        <v-spacer></v-spacer>
        <v-btn @click="closeModal()" left text fab small color="white">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-alert type="info" text class="mt-4 mx-auto font-bold" style="max-width: 600px">
          {{ computedAppointmentDate }} - {{ computedAppointmentTime }}, {{ translate($store.getters.content.duration) }}
          {{ computedSelectedSlot.duration }} {{ translate($store.getters.content.minutes) }}
        </v-alert>
        <v-form ref="confirmForm">
          <!-- <div class="my-4">
            <label class="primary--text title">{{ translate($store.getters.content.personal_info) }}</label>
            <v-divider class="title-border"></v-divider>
          </div>-->

          <!-- first name  -->
          <v-row>
            <v-col sm="6">
              <v-text-field
                outlined
                readonly
                :label="translate($store.getters.content.first_name)"
                type="text"
                :value="formData.firstName"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <!-- last name  -->
              <v-text-field
                outlined
                readonly
                :label="translate($store.getters.content.last_name)"
                type="text"
                :value="formData.lastName"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="6">
              <v-text-field outlined readonly :label="translate($store.getters.content.location)" type="text" :value="locationInfo"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="py-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeModal()">{{ translate($store.getters.content.cancel) }}</v-btn>
        <v-btn color="success" :disabled="submittingForm" @click="bookAppointment()" class="mx-4">
          {{ translate($store.getters.content.submit_form) }}
          <v-icon right>mdi-send</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import { AppointmentFormFieldKeys } from '@/store/models/appointment-form-field-keys.js';

export default {
  mixins: [SharedFunctions],
  props: ['caseInfo', 'doctorOptions', 'location'],
  data() {
    return {
      formDataPrestine: JSON.stringify(new AppointmentFormFieldKeys()),
      formData: new AppointmentFormFieldKeys(),
      applicationDateMenuOpen: false,
      appointmentDateMenuOpen: false,
      appointmentDate: null,
      sampleDateMenuOpen: false,
      required: false,
      disabled: true,
      submittingForm: false,
      tokenId: null,
    };
  },
  watch: {
    // appointmentDialog(n, o) {
    //   if (this.$refs.confirmForm && n != o) this.$refs.confirmForm.reset();
    // }
  },
  computed: {
    selectedDateTime() {
      return this.$store.state.appointmentsSelectedDayPage.selectedAppoinmentDateTime;
    },
    computedAppointmentDate() {
      return this.selectedDateTime ? moment.utc(this.selectedDateTime, 'YYYY-MM-DDTHH:mm').local().format('D-MMMM-YYYY') : '';
    },
    computedAppointmentTime() {
      return this.selectedDateTime ? moment.utc(this.selectedDateTime, 'YYYY-MM-DDTHH:mm').local().format('hh:mm A') : '';
    },
    computedBirthDate() {
      return this.formData.birthDate ? moment(this.formData.birthDate, 'YYYY-MM-DD').format('D-MMMM-YYYY') : '';
    },
    computedSelectedSlot() {
      return this.$store.state.appointmentsSelectedDayPage.selectedSlot;
    },
    appointmentDialog() {
      return this.$store.state.appointmentsSelectedDayPage.showAppointmentBookingDialog;
    },
    code() {
      return this.$store.state.intakeFormData.code;
    },
    codeId() {
      return this.$store.state.intakeFormData.codeId;
    },
    locations() {
      return this.$store.state.appointmentsCalendarPage.locations;
    },
    locationInfo() {
      for (let i = 0; i < this.locations.length; i++) {
        const location = this.locations[i];
        if (location.id == this.location) {
          return location.name + ', ' + location.address;
        }
      }
      return '';
    },
  },
  created() {
    if (this.locations && this.locations.length == 0) this.getLocations();
  },
  mounted() {
    this.getCaseInfo();
  },
  methods: {
    closeModal() {
      this.$store.commit('SET_APPOINTMENT_BOOKING_DIALOG', false);
    },
    reloadPageData() {
      let selectedDate = this.$store.state.appointmentsSelectedDayPage.selectedDate;
      this.$store.commit('SET_SINLGE_SLOT_LOADER', { id: this.computedSelectedSlot.id, action: true });
      this.$store
        .dispatch('GET_CALENDAR_DAY_SLOTS', {
          minDate: selectedDate,
          maxDate: selectedDate,
          showLoader: false,
        })
        .finally(() => {
          this.$store.commit('SET_SINLGE_SLOT_LOADER', { id: this.computedSelectedSlot.id, action: false });
        });
      this.$store.dispatch('getCalenderDayManualAppointments', {
        minDate: selectedDate,
        maxDate: selectedDate,
      });
    },
    getCaseInfo() {
      this.formData.address = this.caseInfo.accommodationAddress;
      this.formData.birthDate = this.caseInfo.birthDay;
      this.formData.email = this.caseInfo.email;
      this.formData.firstName = this.caseInfo.firstname;
      this.formData.lastName = this.caseInfo.lastname;
      this.formData.phone = this.caseInfo.phonenumber;
      this.formData.azvNumber = this.caseInfo.azvNumber;
      this.formData.doctorId = this.caseInfo.doctorEntry.id;
      this.formData.applicationDate = moment().format('YYYY-MM-DD') + 'T13:00:00.000Z[UTC]';
      this.appointmentDate = moment(this.selectedDate).format('YYYY-MM-DD');
    },
    doctor(id) {
      for (let doctorId in this.doctorOptions) {
        if (this.doctorOptions[doctorId] != undefined) {
          if (id == this.doctorOptions[doctorId].value) {
            return this.doctorOptions[doctorId].text;
          }
        }
      }
    },
    bookAppointment() {
      const agendaSlotId = this.computedSelectedSlot.id;

      const dataToPost = {
        slotId: agendaSlotId,
        tokenId: this.codeId,
      };

      this.$store.dispatch('SUBMIT_APPOINTMENT', dataToPost).then((data) => {
        this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });

        if (data) {
          let payload = {
            open: true,
            text: 'Appointment successfully created.',
            color: 'success',
          };
          this.$store.commit('SET_SNACKBAR', payload);
          this.$store.commit('SET_CODE_INFO', null);
          this.$router.push({ name: 'Home' });
        }
      });
    },
    getLocations() {
      this.$store
        .dispatch('GET_LOCATIONS', {
          code: this.code.code,
        })
        .then((data) => {
          if (data) {
            this.$store.commit('SET_LOCATIONS', data);
          }
        });
    },
  },
};
</script>
